import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import IconButton from "@material-ui/core/IconButton";
import classNames from "../utils/classNames";

import { Icon } from "./icons/Icon";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: 0,
    display: "flex",
    boxShadow: theme.shadows[1]
  },
  message: {
    padding: 0,
    flex: 1
  },
  action: {
    margin: 0,
    padding: "0 0.5em 0 1em"
  },
  success: {
    backgroundColor: "#e0f0d7",
    color: "#447e49"
  },
  error: {
    backgroundColor: "#f9dcdc", // "#f1dede",
    color: "#ad2f31"
  },
  warning: {
    backgroundColor: "#fdf8e2",
    color: "#8d713a"
  },
  info: {
    backgroundColor: "white",
    color: theme.palette.primary.main
  }
}));

export type Tvariant = "success" | "error" | "warning" | "info";

type Props = {
  message: string;
  variant: Tvariant;
  className?: string;
  onClose?: () => void;
};

const variantIconMapper = {
  success: "check_circle",
  error: "error",
  warning: "warning",
  info: "info"
};

export const Message: React.FC<Props> = ({
  message,
  className,
  onClose,
  variant
}) => {
  const classes = useStyles();
  const variantIcon = variantIconMapper[variant];

  return (
    <SnackbarContent
      className={classNames(classes.root, classes[variant], className)}
      classes={{ message: classes.message, action: classes.action }}
      message={
        <div
          style={{
            display: "flex",
            alignItems: "center",
            padding: "1em",
            fontSize: "1rem"
          }}
        >
          <Icon
            name={variantIcon}
            style={{ fontSize: "1rem", marginRight: "0.5em", marginTop: 1 }}
          />
          <div>{message}</div>
        </div>
      }
      action={
        onClose ? (
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={onClose}
          >
            <Icon name="close" style={{ fontSize: "0.8rem" }} />
          </IconButton>
        ) : null
      }
    />
  );
};

type ErrorProps = {
  error: Error;
  className?: string;
};

export const ErrorMessage: React.FC<ErrorProps> = ({ error, className }) => {
  return (
    <Message className={className} variant="error" message={error.message} />
  );
};
